/**
 * Component Registry for Weidner Apartment Homes Theme
 * 
 * Extends the base theme-homestead theme registry with Weidner Apartment Homes specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-theme-homestead/registry';
// Side-effect: CTA hover CSS rides the registry import graph so every child
// site that spreads this registry gets the rules in its Vite/SSG bundle —
// not only when this theme's main.tsx loads index.css.
import './index.css';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { CortLeadFormCta } from './components/CortLeadFormCta';
import { Deals } from './components/Deals';
import { DallasMavericksGames } from './components/DallasMavericksGames';
import { QualifyingCriteria } from './components/QualifyingCriteria';
import { GalleryGrid } from './components/GalleryGrid';
import { FloorPlansIntro } from './components/FloorPlansIntro';
import { ParallaxBanner } from './components/ParallaxBanner';
import { FloorplansList } from './components/FloorplansList';
import { HeroCallouts } from './components/HeroCallouts';
import { PropertyOverview } from './components/PropertyOverview';
import { PetPolicy } from './components/PetPolicy';
import { AmenitiesList } from './components/AmenitiesList';
import { ContactForm } from './components/ContactForm';
import { ScheduleTourForm } from './components/ScheduleTourForm';

/**
 * Weidner Apartment Homes specific component overrides.
 * These components have been customized for the Weidner Apartment Homes brand.
 */
const weidnerapartmenthomesOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  Hero,
  HeroSolidBG,
  CortLeadFormCta,
  Deals,
  DallasMavericksGames,
  QualifyingCriteria,
  GalleryGrid,
  FloorPlansIntro,
  ParallaxBanner,
  FloorplansList,
  HeroCallouts,
  PropertyOverview,
  PetPolicy,
  AmenitiesList,
  ContactForm,
  ScheduleTourForm,
};

/**
 * Final merged registry for Weidner Apartment Homes properties.
 * Inherits all components from the theme-homestead theme, with Weidner Apartment Homes overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...weidnerapartmenthomesOverrides,
};

export default registry;
